var _polygon, _polygon2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlexSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 480 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "232.69 0 232.69 235.55 480 386.05 480 0 232.69 0"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "0 93.95 0 480 247.31 480 247.31 244.45 0 93.95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexSquare);
export default __webpack_public_path__ + "static/media/FlexSquare.10e9eb1ddf659bedeb9ab53b4194772f.svg";
export { ForwardRef as ReactComponent };